import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/tkcdigital.webp';
import screenshot_target from '../../../images/letterfunnel/tinkybart.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Tinky Bart"
      firstname="Tinky"
      companyname="TKC Digital"
      competition="Cvision en Info Support"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/tinkybart.js